import { Platform, useWindowDimensions, ViewStyle } from 'react-native';
import { designTokens } from '../theme/design-system';

/** Side gutter for a full-width form on phone-sized screens. */
export const PHONE_WEB_FORM_GUTTER = 12;

/**
 * Horizontal padding override for a main form's scroll content on phones
 * (native, or a browser narrower than the tablet breakpoint) — undefined on
 * wider screens, so tablet/desktop keep each form's own spacing.
 *
 * On native, ScreenLayout already pads its content by spacing.screenPadding
 * (16), so the form adds none of its own; a phone browser gets no
 * ScreenLayout padding (see ScreenLayout's isMobileBrowser override), so the
 * form supplies the gutter itself. Either way the visible side gap is a
 * single gutter instead of ScreenLayout's padding plus the form's own
 * spacing.lg (40px on native, 36px+ on web).
 */
export function usePhoneFormGutter(): ViewStyle | undefined {
  const { width } = useWindowDimensions();
  const isPhoneWidth = width < designTokens.breakpoints.tablet;
  if (!isPhoneWidth) return undefined;
  return { paddingHorizontal: Platform.OS === 'web' ? PHONE_WEB_FORM_GUTTER : 0 };
}
